import { Component, Output, EventEmitter, Input, HostBinding } from '@angular/core';

export interface BbResizeHandleDragEvent {
	mouseEvent: MouseEvent;
	direction: string;
}

@Component({
	selector: 'bb-resize-handles',
	templateUrl: './bb-resize-handles.component.html',
	styleUrls: ['./bb-resize-handles.component.scss']
})

export class BbResizeHandlesComponent {
	@Input() public direction: 'horizontal' | 'vertical';
	@Input() public invisibleHandles = false;
	@Input() public handleStyle: 'default' | 'brackets' = 'default';

	@Output() public mouseDownEvent: EventEmitter<BbResizeHandleDragEvent> = new EventEmitter();

	@HostBinding('class.invisible-handles')
	get hideHandles() {
		return this.invisibleHandles;
	}
	@HostBinding('class.bracket-handles')
	get bracketHandles() {
		return this.handleStyle === 'brackets';
	}

	constructor() { }

	onMouseEvent(ev: MouseEvent, direction: string) {
		const resizeEvent: BbResizeHandleDragEvent = {
			mouseEvent: ev,
			direction
		};
		this.mouseDownEvent.emit(resizeEvent);
	}
}
